import React, { useState, useEffect } from "react";
import StarRatings from "react-star-ratings";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import { Link } from "react-router-dom";

import Header from "../components/header";
import Footer from "../components/footer";
import AppAds from "../landingpage/appads";

import {
	IcMinusGreen,
	IcPlus,
	Saving,
	Phone,
	Star,
	Stars,
	Message,
	Promo,
	Secure,
	Money,
	LowCost,
	Setting,
} from "../common/svg";
import { Mode } from "../common/common";

import bg_white from "../../static/images/introRegisterOwner/bg-content-banner.png";
import banner from "../../static/images/introRegisterOwner/bg_top.png";
import adv_1 from "../../static/images/aboutus/advantage1.svg";
import adv_2 from "../../static/images/aboutus/advantage2.svg";
import adv_3 from "../../static/images/aboutus/advantage3.svg";
import adv_4 from "../../static/images/aboutus/advantage4.svg";
import adv_5 from "../../static/images/aboutus/advantage5.svg";

import { WHY, M_WHY } from "../../constant/routes";

const ADVANTAGE_LIST = [
	{ id: 1, img: adv_1, desc: `Đặt xe bằng 1 Click` },
	{ id: 2, img: adv_2, desc: `Hơn 100 mẫu xe` },
	{ id: 3, img: adv_3, desc: `Mioto đã có mặt ở hầu hết các quận huyện và các tỉnh thành lớn` },
	{ id: 4, img: adv_4, desc: `Rẻ hơn 10% xe truyền thốn` },
	{ id: 5, img: adv_5, desc: `Thu nhập 10 - 15 triệu/tháng` },
];

const REASON_TRAVELER = [
	{
		id: 1,
		title: "Tiết kiệm",
		ic: <Saving />,
		ct: "Giá thuê xe bình quân thấp hơn dao động từ 10-20% so với thị trường.",
	},
	{
		id: 2,
		title: "Nhanh chóng và tiện lợi",
		ic: <Phone />,
		ct: "Dễ dàng đặt xe mọi lúc, mọi nơi với quy trình đơn giản và nhanh chóng chỉ mất từ 5-10 phút.",
	},
	{
		id: 3,
		title: "Trải nghiệm mới lạ",
		ic: <Stars />,
		ct: "Thoải mái tìm kiếm và lựa chọn nhiều dòng xe khác nhau phù hợp với sở thích và ngân sách của bạn.",
	},
	{
		id: 4,
		title: "Chương trình khuyến mãi",
		ic: <Promo />,
		ct: "Nhiều chương trình khuyến mãi hấp dẫn khác dành cho khách thuê.",
	},
	{
		id: 5,
		title: "An toàn và uy tín",
		ic: <Secure />,
		ct: "An toàn và uy tín",
	},
	{
		id: 6,
		title: "Đội ngũ hỗ trợ",
		ic: <Message />,
		ct: "Bộ phận CSKH của Mioto luôn bên cạnh để hỗ trợ bạn trong mọi tình huống.",
	},
	{
		id: 7,
		title: "Tiện ích vượt trội",
		ic: <Star />,
		ct: 'Dễ dàng tìm kiếm và đặt xe trên cả 2 nền tảng Website Mioto.vn và ứng dụng Mioto. Xem trước lịch trình xe và báo giá thuê xe theo từng ngày. Cho phép đánh giá xe và chủ xe với tính năng "Rating".',
	},
];

const REASON_OWNER = [
	{
		id: 1,
		title: "Doanh thu cao",
		ic: <Money />,
		ct: "Tiếp cận kênh thuê xe online với số lượng lớn khách hàng tiềm năng của Mioto giúp gia tăng đáng kể thu nhập từ xe của Bạn (trung bình 5-15 triệu đồng/tháng, tùy thuộc dòng xe và số ngày cho thuê).",
	},
	{
		id: 2,
		title: "Chi phí thấp",
		ic: <LowCost />,
		ct: "Không tốn phí đăng kí và phí duy trì. Chỉ phát sinh phí vận hành khi có giao dịch cho thuê (15%/giá thuê).",
	},
	{
		id: 3,
		title: "Linh hoạt",
		ic: <Stars />,
		ct: "Cho thuê xe bất cứ khi nào bạn muốn. Toàn quyền sử dụng xe khi cần.",
	},
	{
		id: 4,
		title: "Chủ động",
		ic: <Setting />,
		ct: "Toàn quyền thiết lập giá thuê xe và các yêu cầu riêng.",
	},
	{
		id: 5,
		title: "An toàn",
		ic: <Secure />,
		ct: "Dễ dàng kiểm tra lịch sử thuê xe của khách trên ứng dụng Mioto trước khi quyết định cho thuê.",
	},
	{
		id: 6,
		title: "Tiện ích vượt trội",
		ic: <Star />,
		ct: 'Dễ dàng đăng kí và cho thuê xe trên cả 2 nền tảng Website Mioto.vn và Ứng dụng Mioto.Thuận tiện quản lí và theo dõi lịch trình xe với tính năng "Calendar".Cho phép phản hồi và đánh giá khách thuê với tính năng "Rating".* Dễ dàng theo dõi xe của bạn với tính năng "GPS" (Tính năng dự kiến ra mắt trong năm 2018. Mioto hỗ trợ cài đặt cho chủ xe với giá gốc ước tính 500,000đ/thiết bị)',
	},
	{
		id: 7,
		title: "Chính sách ưu đãi",
		ic: <Promo />,
		ct: "Giá ưu đãi dành riêng cho chủ xe khi thuê xe trong cộng đồng Mioto.Các chương trình khuyến mãi hấp dẫn khác dành riêng cho chủ xe.",
	},
	{
		id: 8,
		title: "Đội ngũ hỗ trợ",
		ic: <Message />,
		ct: "Bộ phận CSKH của Mioto luôn bên cạnh để hỗ trợ bạn trong mọi tình huống.",
	},
];

const VEHICLES_CHOICE = [
	{
		id: 1,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Xe 4 chỗ (Mini)`,
		total: `200+ xe`,
	},
	{
		id: 2,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Xe 4 chỗ (Sedan)`,
		total: `200+ xe`,
	},
	{
		id: 3,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Xe 4 chỗ (Hatchback)`,
		total: `200+ xe`,
	},
	{
		id: 4,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Xe 5 chỗ (Gầm cao)`,
		total: `200+ xe`,
	},
	{
		id: 5,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Xe 7 chỗ (Gầm cao)`,
		total: `200+ xe`,
	},
	{
		id: 6,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Xe 7 chỗ (Gầm thấp)`,
		total: `200+ xe`,
	},
	{
		id: 7,
		img: "https://n1-cstg.mioto.vn/g/2023/03/30/17/77NR3UTH.jpg",
		title: `Bán tải`,
		total: `200+ xe`,
	},
];

const EXPERIENCE_CHOICE = [
	{
		id: 1,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Dã ngoại`,
		total: `200+ xe`,
	},
	{
		id: 2,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Đi biển`,
		total: `200+ xe`,
	},
	{
		id: 3,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Khám phá`,
		total: `200+ xe`,
	},
	{
		id: 4,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Công tác`,
		total: `200+ xe`,
	},
	{
		id: 5,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Gia đình`,
		total: `200+ xe`,
	},
	{
		id: 6,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Hội nhóm`,
		total: `200+ xe`,
	},
	{
		id: 7,
		img: "https://n1-cstg.mioto.vn/v4/p/m/icons/features/usb-v2.png",
		title: `Cưới hỏi`,
		total: `200+ xe`,
	},
];

const TOP_DESTINATION_LIST = [
	{
		id: 1,
		img: "https://n1-cstg.mioto.vn/1/cho_thue_xe_tu_lai_tphcm/hcm/p/m/cities_v2/HoChiMinh_v2.jpg",
		title: `Hồ Chí Minh`,
		totalTrip: `200 chuyến`,
		totalCar: `200 xe`,
	},
	{
		id: 2,
		img: "https://n1-cstg.mioto.vn/1/cho_thue_xe_tu_lai_tphcm/hcm/p/m/cities_v2/HoChiMinh_v2.jpg",
		title: `Hà Nội`,
		totalTrip: `200 chuyến`,
		totalCar: `200 xe`,
	},
	{
		id: 3,
		img: "https://n1-cstg.mioto.vn/1/cho_thue_xe_tu_lai_tphcm/hcm/p/m/cities_v2/HoChiMinh_v2.jpg",
		title: `Đà Nẵng`,
		totalTrip: `200 chuyến`,
		totalCar: `200 xe`,
	},
	{
		id: 4,
		img: "https://n1-cstg.mioto.vn/1/cho_thue_xe_tu_lai_tphcm/hcm/p/m/cities_v2/HoChiMinh_v2.jpg",
		title: `Quảng Trị`,
		totalTrip: `200 chuyến`,
		totalCar: `200 xe`,
	},
	{
		id: 5,
		img: "https://n1-cstg.mioto.vn/1/cho_thue_xe_tu_lai_tphcm/hcm/p/m/cities_v2/HoChiMinh_v2.jpg",
		title: `Quê Tôi`,
		totalTrip: `200 chuyến`,
		totalCar: `200 xe`,
	},
];

const REVIEW_LIST = [
	{
		id: 1,
		img: `https://media-cdn-v2.laodong.vn/Storage/NewsPortal/2021/11/19/975665/Kieu-Toc-Son-Tung-Mt.jpeg`,
		serviceType: 1,
		name: "Tú Phan Như Sơn Tùng",
		star: 5,
		time: "5 tiếng trước",
		comment: `điều chỉnh giá thuê xe. Cho phép khách thuê xem trước lịch trình xe`,
	},
	{
		id: 2,
		img: `https://media-cdn-v2.laodong.vn/Storage/NewsPortal/2021/11/19/975665/Kieu-Toc-Son-Tung-Mt.jpeg`,
		serviceType: 2,
		name: "Tú Phan Như Sơn Tùng",
		star: 3,
		time: "2 tiếng trước",
		comment: `Hỗ trợ chủ xe thuận tiện quản lí, theo dõi lịch trình xe một cách khoa học và hoàn toàn chủ động trong việc thiết lập và điều chỉnh giá thuê xe. Cho phép khách thuê xem trước lịch trình xe`,
	},
	{
		id: 3,
		img: `https://media-cdn-v2.laodong.vn/Storage/NewsPortal/2021/11/19/975665/Kieu-Toc-Son-Tung-Mt.jpeg`,
		serviceType: 2,
		name: "Tú Phan Như Sơn Tùng",
		star: 4,
		time: "5 tiếng trước",
		comment: ``,
	},
	{
		id: 4,
		img: `https://media-cdn-v2.laodong.vn/Storage/NewsPortal/2021/11/19/975665/Kieu-Toc-Son-Tung-Mt.jpeg`,
		serviceType: 1,
		name: "Tú Phan Như Sơn Tùng",
		star: 5,
		time: "5 tiếng trước",
		comment: `Hỗ trợ chủ xe thuận tiện quản lí, theo dõi lịch trình xe một cách khoa học và hoàn toàn chủ động trong việc thiết lập và điều chỉnh giá thuê xe. Cho phép khách thuê xem trước lịch trình xe`,
	},
];

const FEATURE_LIST = [
	{
		id: 0,
		title: `Tính năng calendar`,
		answers: [
			`Hỗ trợ chủ xe thuận tiện quản lí, theo dõi lịch trình xe một cách khoa học và hoàn toàn chủ động trong việc thiết lập và điều chỉnh giá thuê xe. Cho phép khách thuê xem trước lịch trình xe và nhận báo giá thuê xe theo từng ngày.`,
			`Chính vì thế, tính năng Calendar sẽ giúp loại bỏ hoàn toàn công đoạn liên lạc bằng điện thoại giữa chủ xe và khách thuê trong việc trao đổi thời gian và giá thuê xe, qua đó rút ngắn đáng kể thời gian đặt xe.`,
		],
	},
	{
		id: 1,
		title: `Tính năng đánh giá`,
		answers: [
			`Cho phép khách thuê xe chấm điểm và gửi nhận xét đến chủ xe cũng như xe được thuê. Nhờ đó, khách thuê xe có thông tin làm cơ sở để có thể lựa chọn các chủ xe uy tín, các xe có chất lượng tốt trước khi quyết định đặt xe.`,
			`Tính năng Rating của Mioto cũng cho phép chủ xe có thể gửi các phản hồi và chấm điểm ngược lại đối với khách thuê xe. Từ đó giúp nâng cao hơn nữa chất lượng thành viên trong cộng đồng thuê xe tự lái Mioto.`,
		],
	},
	{
		id: 2,
		title: `Đặt xe nhanh và giao nhận xe tận nơi`,
		answers: [
			`Bạn không có nhiều thời gian, bạn muốn thuê xe nhanh chóng không cần qua bước xét duyệt online của chủ xe? Bạn muốn xe đươc đem đến tận nơi trước cửa nhà của bạn hay đón bạn trực tiếp tại phi trường? Tính năng “Đặt xe nhanh” và “Giao xe tận nơi” của Mioto sẽ đáp ứng hoàn hảo các yêu cầu này của bạn.`,
			`Tại Mioto, chúng tôi có một danh sách dài các chủ xe sẵn sàng cung cấp dịch vụ giao xe tận nơi và cho phép bạn thuê xe không cần xét duyệt online (chỉ cần kiểm tra trực tiếp khi bàn giao xe).`,
		],
	},
	{
		id: 3,
		title: `GPS mọi nẻo đường`,
		answers: [
			`Mioto biết rằng xe ô tô là tài sản lớn của bạn và kinh doanh cho thuê xe tự lái sẽ luôn tiềm ẩn rủi ro. Vì thế, bên cạnh viêc hỗ trợ bạn với công đoạn xác minh trước những thông tin cá nhân quan trọng của khách hàng (Giấy phép lái xe, Sổ hộ khẩu và điểm rating), chúng tôi đang phát triển thêm tính năng GPS tích hợp trực tiếp trên ứng dụng.`,
			`Với tính năng GPS, chủ xe có thể dễ dàng theo dõi hiện trạng và vị trí xe của mình ngay trên ứng dụng, bất cứ lúc nào và bất cứ đâu để bạn có thể hoàn toàn an tâm về chiếc xe của mình.`,
		],
	},
];

const Banner = ({ isMobile }) => {
	return (
		<div className="banner-top-sect">
			<div className="m-container">
				<div className="background space sec" style={{ backgroundImage: `url(${banner})` }} />
				<div className="content-container">
					<img loading="lazy" className="bg-content" src={bg_white} />
					<div className="main-content">
						<h3>Vì sao chọn Mioto?</h3>
						<p>
							Mioto không thu phí khi bạn đăng xe. Bạn chỉ chia sẻ phí dịch vụ với Mioto khi có giao dịch cho thuê thành
							công.
						</p>
						{/* <div className="line"> </div>
						<Link to={isMobile ? M_WHY : WHY} className="btn btn--m btn-primary">
							Cùng khám phá
						</Link> */}
					</div>
				</div>
			</div>
		</div>
	);
};

const Advantage = () => {
	return (
		<div className="aboutus-advantage space sec">
			<div className="m-container">
				<h2>Lợi thế của Mioto</h2>
				<div className="list-adv">
					{ADVANTAGE_LIST.map((item) => (
						<div className="adv-item" key={item.id}>
							<img loading="lazy" src={item.img} />
							<h5>{item.desc}</h5>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

const ReasonItem = ({ reason }) => {
	return (
		<div>
			<div className="list-reason isOffTablet">
				{reason.map((rs) => (
					<div key={rs.id} className={`reason-item`}>
						<div className="green-card-option">
							<div className="number">{rs.id}.</div>
							<div className="wrap-svg">{rs.ic}</div>
							<h6>{rs.title}</h6>
							<p>{rs.ct}</p>
						</div>
					</div>
				))}
			</div>
			<Swiper
				className="isShowTablet swiper-aboutus-why"
				slidesPerView={1.25}
				spaceBetween={15}
				modules={[Pagination]}
				pagination={{
					el: ".pagi-reason",
					clickable: true,
					dynamicBullets: true,
				}}
				breakpoints={{
					768: {
						slidesPerView: 2,
						spaceBetween: 15,
					},
					577: {
						slidesPerView: 1.5,
						spaceBetween: 15,
					},
				}}>
				{reason.map((rs) => (
					<SwiperSlide key={rs.id}>
						<div className={`reason-item`}>
							<div className="green-card-option">
								<div className="number">{rs.id}.</div>
								<div className="wrap-svg">{rs.ic}</div>
								<h6>{rs.title}</h6>
								<p>{rs.ct}</p>
							</div>
						</div>
					</SwiperSlide>
				))}
				<div className="swiper-pagination pagi-reason" />
			</Swiper>
		</div>
	);
};

const Reason = () => {
	const [mode, setMode] = useState(Mode.TRAVELER);
	return (
		<div className="aboutus-why space sec">
			<div className="m-container">
				<div className="category-option">
					{mode === Mode.TRAVELER ? (
						<h4>
							Khách thuê xe -<br />
							Tại sao nên thuê xe tại Mioto?
						</h4>
					) : (
						<h4>
							Chủ xe -<br />
							Tại sao nên đăng kí xe tại Mioto?
						</h4>
					)}
					<div className="category-type">
						<a className={`btn btn-type ${mode === Mode.OWNER ? "active" : ""}`} onClick={() => setMode(Mode.OWNER)}>
							Chủ xe
						</a>
						<a
							className={`btn btn-type ${mode === Mode.TRAVELER ? "active" : ""}`}
							onClick={() => setMode(Mode.TRAVELER)}>
							Khách thuê xe
						</a>
					</div>
				</div>
				{mode === Mode.TRAVELER ? <ReasonItem reason={REASON_TRAVELER} /> : <ReasonItem reason={REASON_OWNER} />}
			</div>
		</div>
	);
};

const MultiChoice = () => {
	return (
		<div className="pickup-section space sec">
			<div className="m-container">
				<h2>Đa dạng lựa&nbsp;chọn&nbsp;xe</h2>
				<p className="subtitle">
					Công ty Cổ phần Mioto Asia hoạt động trên nền tảng ứng dụng cho thuê xe tự lái 4-7 chỗ, theo mô hình kinh tế
					sẻ chia. Mioto được thành lập với sứ mệnh.
				</p>
			</div>
			<div className="m-container marginBottom-l">
				<h5>Tìm theo dòng xe</h5>
				<Swiper
					className="swiper-pickup"
					slidesPerView={1.5}
					spaceBetween={12}
					modules={[Navigation, Pagination]}
					navigation={{
						nextEl: ".pickup-next",
						prevEl: ".pickup-prev",
					}}
					pagination={{
						el: ".pagi-pickup",
						clickable: true,
						dynamicBullets: true,
					}}
					breakpoints={{
						1400: {
							slidesPerView: 6,
						},
						1200: {
							slidesPerView: 5,
						},
						992: {
							slidesPerView: 4,
						},
						768: {
							slidesPerView: 3,
						},
						481: {
							slidesPerView: 2,
						},
					}}>
					{VEHICLES_CHOICE.map((item) => (
						<SwiperSlide key={item.id}>
							<div className="fix-img">
								<img loading="lazy" src={item.img} />
							</div>
							<p className="name">{item.title}</p>
							<p className="total">{item.total}</p>
						</SwiperSlide>
					))}
					<div className="swiper-pagination pagi-pickup" />
				</Swiper>
				<div className="swiper-button-prev pickup-prev" />
				<div className="swiper-button-next pickup-next" />
			</div>
			<div className="m-container">
				<h5>Tìm theo trải nghiệm</h5>
				<Swiper
					className="swiper-pickup experience"
					slidesPerView={1.5}
					spaceBetween={12}
					modules={[Navigation, Pagination]}
					navigation={{
						nextEl: ".experience-next",
						prevEl: ".experience-prev",
					}}
					pagination={{
						el: ".pagi-pickup",
						clickable: true,
						dynamicBullets: true,
					}}
					breakpoints={{
						1400: {
							slidesPerView: 6,
						},
						1200: {
							slidesPerView: 5,
						},
						992: {
							slidesPerView: 4,
						},
						768: {
							slidesPerView: 3,
						},
						481: {
							slidesPerView: 2,
						},
					}}>
					{EXPERIENCE_CHOICE.map((item) => (
						<SwiperSlide key={item.id}>
							<img loading="lazy" src={item.img} />
							<p className="name">{item.title}</p>
							<p className="total">{item.total}</p>
						</SwiperSlide>
					))}
					<div className="swiper-pagination pagi-pickup" />
				</Swiper>
				<div className="swiper-button-prev experience-prev" />
				<div className="swiper-button-next experience-next" />
			</div>
		</div>
	);
};

const TopDestination = () => {
	return (
		<div className="topdes-section space sec">
			<div className="m-container">
				<div className="title">
					<h2>Cùng bạn ở bất&nbsp;kỳ&nbsp;đâu</h2>
					<div className="pick-topdes">
						<div className="pick-topdes__item active">Tất cả</div>
						<div className="pick-topdes__item">Top 10 địa danh</div>
						<div className="pick-topdes__item">Khám phá - mạo hiểm</div>
						<div className="pick-topdes__item">Trải nghiệm lần đầu</div>
					</div>
				</div>
			</div>
			<div className="m-container">
				<Swiper
					className="swiper-topdes-city"
					spaceBetween={10}
					slidesPerView={1.4}
					modules={[Navigation, Pagination]}
					pagination={{
						el: ".pagi-topdes",
						clickable: true,
						dynamicBullets: true,
					}}
					navigation={{
						nextEl: ".topdes-next",
						prevEl: ".topdes-prev",
					}}
					breakpoints={{
						1200: {
							slidesPerView: 4,
						},
						992: {
							slidesPerView: 3.5,
						},
						768: {
							slidesPerView: 3,
						},
						577: {
							slidesPerView: 2.3,
						},
						481: {
							slidesPerView: 2,
						},
					}}>
					{TOP_DESTINATION_LIST.map((item) => (
						<SwiperSlide key={item.id}>
							<a>
								<div className="fix-img car-glass">
									<img loading="lazy" src={item.img} />
								</div>
								<p>
									{item.title}
									<span>
										{" "}
										{item.totalTrip} • {item.totalCar}
									</span>
								</p>
							</a>
						</SwiperSlide>
					))}
					<div className="swiper-pagination pagi-topdes" />
				</Swiper>
				<div className="swiper-button-prev topdes-prev" />
				<div className="swiper-button-next topdes-next" />
			</div>
		</div>
	);
};

const Reviews = () => {
	return (
		<div className="review-aboutus-section space sec">
			<div className="m-container">
				<h2>Đánh giá từ khách&nbsp;hàng</h2>
				<Swiper
					className="swiper-review"
					slidesPerView={1}
					spaceBetween={12}
					modules={[Navigation, Pagination]}
					navigation={{
						nextEl: ".review-next",
						prevEl: ".review-prev",
					}}
					pagination={{
						el: "pagi-review",
						clickable: true,
						dynamicBullets: true,
					}}
					breakpoints={{
						1200: {
							slidesPerView: 3,
						},
						992: {
							slidesPerView: 2,
						},
						481: {
							slidesPerView: 1.5,
						},
					}}>
					{REVIEW_LIST.map((item) => (
						<SwiperSlide key={item.id}>
							<div className="item-review">
								<div className="profile">
									<div className="desc">
										<a className="avatar avatar--m">
											<img loading="lazy" src={item.img} />
										</a>
										<div className="info">
											<span className="tag-item transmission">
												{item.serviceType === 1 ? `Xe tự lái` : `Xe có tài`}
											</span>
											<a>
												<h6>{item.name}</h6>
											</a>
											<div className="rate">
												<StarRatings
													rating={item.star}
													starRatedColor="#FFC634"
													starDimension="17px"
													starSpacing="1px"
												/>
												<div className="time">{item.time}</div>
											</div>
										</div>
									</div>
								</div>
								<pre className="main-review">{item.comment}</pre>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
				<div className="swiper-button-prev review-prev" />
				<div className="swiper-button-next review-next" />
			</div>
		</div>
	);
};

const SalientFeatures = () => {
	const [shownFeature, setShownFeature] = useState({});

	const toggleFeature = (i) => {
		setShownFeature({
			...shownFeature,
			[i]: !shownFeature[i],
		});
	};

	return (
		<div className="salient-features space sec">
			<div className="m-container">
				<h3>Tính năng nổi bật có tại MIOTO</h3>
				<div className="list-ques-feature">
					<div className="list-ques-short">
						{FEATURE_LIST.map((feature) => (
							<div key={feature.id} className={`question-item ${shownFeature[feature.id] ? "active" : ""}`}>
								<div className="ques" onClick={() => toggleFeature(feature.id)}>
									{feature.title}
									<div className="wrap-svg ic-active">{shownFeature[feature.id] ? <IcMinusGreen /> : <IcPlus />}</div>
								</div>
								{shownFeature[feature.id] && (
									<div className="ans">
										{feature.answers.map((ans) => (
											<p key={ans}>{ans}</p>
										))}
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

const WhyUs = (props) => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
		const isMobile = props.location.pathname.includes("/mobile");
		setIsMobile(isMobile);
	}, []);

	return (
		<div className="mioto-layout">
			{!isMobile && <Header notLineHeader={true} />}
			<section className="body">
				<div className="about-us">
					<Banner isMobile={isMobile} />
					<Advantage />
					<Reason />
					{/* <MultiChoice />
					<TopDestination />
					<Reviews /> */}
					<SalientFeatures />
					<div className="space sec">
						<AppAds />
					</div>
				</div>
			</section>
			{!isMobile && <Footer />}
		</div>
	);
};

export default WhyUs;
